import React from 'react';
import { Users, Award } from 'lucide-react';

const GoverningCouncil = () => {
  const leadership = [
    { name: "Dr. M. Rajmohan", qualification: "M.D.S.", position: "President", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/bemkvf2j_Rajmohan.jpeg" },
    { name: "Dr. D. Kathiravan", qualification: "M.B.B.S., D.M.R.D.", position: "Hon. Secretary", additionalRole: "Founder Treasurer", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/m7q91bx9_Kathiravan.jpeg" },
    { name: "Dr. A.S. Lohanathan", qualification: "M.B.B.S., D.M.R.D.", position: "Treasurer", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/042wgqfw_Dr%20Loganathan.jpeg" },
    { name: "Dr. P. Sankar", qualification: "M.B.B.S., D.Ortho. M.S., M.Ch., (Neuro)", position: "Vice President", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/msusdtmz_Sankar.jpeg" },
    { name: "Mr. S. Sasikumar", qualification: "B.Sc. (Optometry) D.O.A.", position: "Joint Secretary", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/jyc86tzv_sasikumar.jpg" }
  ];

  const councilMembers = [
    { name: "Dr. T. Balasubramanian", qualification: "M.B.B.S., M.D., D.M., (Cardiology)", position: "PATRON", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/axvl5dcf_Balasubramanian.jpeg" },
    { name: "Dr. G.G. Rajvardhavanan", qualification: "M.B.B.S., M.S., M.Ch., (Surgical Oncology)", position: "Founder President, MMT", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/ra789u84_Website%20GGR.jpeg" },
    { name: "Dr. S. Manoharan", qualification: "M.B.B.S., F.C.C.P.", position: "President, IADF", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/9y7w9k6l_Manoharan.jpg" },
    { name: "Dr. Muthu. V. Veermani", qualification: "M.B.B.S., M.S., M.Ch (Urologist)", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/mdoj802j_Dr%20Muthu%20veeramani.jpeg" },
    { name: "Dr. N. Periyasamy Sakya", qualification: "M.B.B.S., M.D., (Anes)", position: "Founder Secretary, MMT", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/22wvauch_Periyasamy%20website.jpg" },
    { name: "Dr. Kalyanasundaram Sattva", qualification: "M.B.B.S., M.S., (Ortho)", position: "Immediate Past President", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/g9lr7nq0_Kalyanasundaram.jpg" },
    { name: "Dr. K. Arivazhagan Daiko", qualification: "M.B.B.S., M.S., (Ortho)", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/prwyltfn_Arivazhagan.jpg" },
    { name: "Er. A. Sivananthan", qualification: "B.E., M.S.", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/yum6wo94_Sivananthan.jpeg" },
    { name: "Dr. D. Ravichandran", qualification: "M.B.B.S., D.C.H.", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/7axgu6qq_Dr%20Ravichandran.jpeg" },
    { name: "Dr. G.M. Muhammad", qualification: "M.B.B.S., M.D (SPM)", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/h1a0jtq7_Muhammad.jpg" },
    { name: "Dr. P. Sasipriya", qualification: "M.B.B.S., M.D.R.T.", position: "President, MMT Women's Wing", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/gnwt3jfj_Sasipriya.jpeg" },
    { name: "Dr. L. Ravi", qualification: "B.H.M.S.", position: "President, Buddhist Society of India, Tamil Nadu Branch", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/ffme1odb_RAVI%20BHMS.jpeg" },
    { name: "Er. S. Paulraj", qualification: "B.E.", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/p5wjii2u_Paulraj.jpg" },
    { name: "Dr. V. Aruldas", qualification: "M.B.B.S., D.C.H.", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/u1ql7l4k_Aruldas.jpg" },
    { name: "Mrs. T. Nandhinidevi", qualification: "B.A., D.T.Ed", photo: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/pjs3lzbf_NANDHINIDEVI.jpeg" }
  ];

  return (
    <section id="team" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 rounded-full mb-4">
            <Users className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-semibold text-blue-700">Our Leadership</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Governing Council
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Dedicated leaders committed to the vision of Prabuddha Bharath
          </p>
        </div>

        {/* Team Photo */}
        <div className="mb-16">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl max-w-5xl mx-auto">
            <img 
              src="https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/dtrnbf4l_MMT%20GC.jpg" 
              alt="MMT Governing Council Members 2025" 
              className="w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
              <p className="text-white text-xl font-semibold text-center">Governing Council Members - 2025</p>
            </div>
          </div>
        </div>

        {/* Organizational Structure */}
        <div className="mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Organizational Structure
          </h3>
          
          {/* Founder President Spotlight */}
          <div className="max-w-4xl mx-auto mb-12">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 md:p-10 shadow-xl border-t-4 border-orange-600">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <img 
                  src="https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/ra789u84_Website%20GGR.jpeg" 
                  alt="Dr. G.G. Rajvardhavanan - Founder President" 
                  className="w-48 h-48 rounded-full object-cover border-8 border-white shadow-2xl"
                />
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-block bg-orange-600 text-white px-6 py-2 rounded-full font-bold text-sm mb-3">
                    FOUNDER PRESIDENT
                  </div>
                  <h3 className="text-4xl font-bold text-orange-900 mb-2">Dr. G.G. Rajvardhavanan</h3>
                  <p className="text-xl text-orange-700 font-semibold mb-4">M.B.B.S., M.S., M.Ch., (Surgical Oncology)</p>
                  <p className="text-gray-700 leading-relaxed">
                    Founder and visionary of Mass Movement for Transformation. Instrumental in establishing MMT in 2015 and pioneering the Buddhist revival movement across Tamil Nadu.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Founder Secretary Spotlight */}
          <div className="max-w-4xl mx-auto mb-12">
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 md:p-10 shadow-xl border-t-4 border-green-600">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <img 
                  src="https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/22wvauch_Periyasamy%20website.jpg" 
                  alt="Dr. N. Periyasamy Sakya - Founder Secretary" 
                  className="w-48 h-48 rounded-full object-cover border-8 border-white shadow-2xl"
                />
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-block bg-green-600 text-white px-6 py-2 rounded-full font-bold text-sm mb-3">
                    FOUNDER SECRETARY
                  </div>
                  <h3 className="text-4xl font-bold text-green-900 mb-2">Dr. N. Periyasamy Sakya</h3>
                  <p className="text-xl text-green-700 font-semibold mb-4">M.B.B.S., M.D., (Anes)</p>
                  <p className="text-gray-700 leading-relaxed">
                    Co-founder and key architect of Mass Movement for Transformation. Dedicated to the principles of Buddhist revival and social transformation.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Leadership Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-12">
            {leadership.map((leader, index) => {
              const colors = [
                { bg: 'bg-green-50', border: 'border-green-600', text: 'text-green-600' },
                { bg: 'bg-orange-50', border: 'border-orange-600', text: 'text-orange-600' },
                { bg: 'bg-purple-50', border: 'border-purple-600', text: 'text-purple-600' },
                { bg: 'bg-yellow-50', border: 'border-yellow-600', text: 'text-yellow-600' }
              ];
              const color = colors[index % colors.length];

              return (
                <div 
                  key={index}
                  className={`${color.bg} p-6 rounded-xl border-2 ${color.border} transform hover:-translate-y-1 transition-all duration-300 shadow-md hover:shadow-xl`}
                >
                  {leader.photo ? (
                    <img 
                      src={leader.photo} 
                      alt={leader.name}
                      className={`w-20 h-20 rounded-full object-cover border-4 ${color.border} mx-auto mb-4`}
                    />
                  ) : (
                    <div className={`w-12 h-12 ${color.bg} rounded-full flex items-center justify-center mb-4 border-2 ${color.border} mx-auto`}>
                      <Award className={`w-6 h-6 ${color.text}`} />
                    </div>
                  )}
                  <h4 className={`text-lg font-bold ${color.text} mb-2 text-center`}>
                    {leader.position}
                  </h4>
                  {leader.additionalRole && (
                    <div className="text-center mb-2">
                      <span className={`inline-block px-3 py-1 ${color.bg} ${color.text} text-xs font-bold rounded-full border ${color.border}`}>
                        {leader.additionalRole}
                      </span>
                    </div>
                  )}
                  <p className="text-gray-900 font-semibold mb-1 text-center">{leader.name}</p>
                  <p className="text-sm text-gray-600 text-center">{leader.qualification}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Governing Council Members */}
        <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Governing Council Members
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {councilMembers.map((member, index) => {
              // Skip Founder President and Founder Secretary as they're shown above
              if (member.position === "Founder President, MMT" || member.position === "Founder Secretary, MMT") {
                return null;
              }
              
              return (
                <div 
                  key={index}
                  className="bg-white p-5 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border-l-4 border-blue-600"
                >
                  {member.photo && (
                    <img 
                      src={member.photo} 
                      alt={member.name}
                      className="w-24 h-24 rounded-full object-cover border-4 border-blue-100 mx-auto mb-4"
                    />
                  )}
                  {member.position && member.position === "PATRON" && (
                    <div className="inline-block px-3 py-1 bg-yellow-100 text-yellow-800 text-xs font-bold rounded-full mb-2">
                      PATRON
                    </div>
                  )}
                  <h4 className="text-base font-bold text-gray-900 mb-2">{member.name}</h4>
                  <p className="text-sm text-gray-600 mb-1">{member.qualification}</p>
                  {member.position && member.position !== "PATRON" && (
                    <p className="text-xs text-blue-600 font-semibold mt-2">{member.position}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Our governing council comprises dedicated professionals committed to social transformation and Buddhist revival.
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
          >
            Connect With Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default GoverningCouncil;